exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preg[data-v-1f79e0dd]{padding:8px!important}.bg-primary[data-v-1f79e0dd]{background-color:#1ab394;border-color:#1ab394;color:#fff}", ""]);

// exports
